import { createGlobalState } from '@vueuse/core';
import type { AxiosResponse } from 'axios';
import { intelligentInboxSettingsClient } from '~/services';
import type { IntelligentInboxSettingsResponse } from '~/services/intelligentInboxSettings/intelligentInboxSettingsClient.types';

export const useIntelligentInboxSettings = createGlobalState(() => {
    const teamId = Spark.state.currentTeam.id;
    let pending: Promise<AxiosResponse<IntelligentInboxSettingsResponse>> | undefined;

    // The inbox and both status filters load at the same time, so they share one request instead of sending three.
    const getSettings = (): Promise<AxiosResponse<IntelligentInboxSettingsResponse>> => {
        pending ??= intelligentInboxSettingsClient.getIntelligentInboxSettings({ teamId }).finally(() => {
            pending = undefined;
        });

        return pending;
    };

    return { getSettings };
});
